(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complete-the-set"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url || this.dataset.loaded) return;
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fresh = doc.querySelector('product-recommendations');
            if (!fresh || !fresh.innerHTML.trim().length) return;
            // The fetched fallback has no page context: never swap in the
            // product we are already on
            const link = fresh.querySelector('a[href]');
            if (link && link.getAttribute('href').split('?')[0] === window.location.pathname) return;
            this.dataset.loaded = 'true';
            this.innerHTML = fresh.innerHTML;
          })
          .catch(() => {});
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.querySelectorAll('[data-country-selector]').forEach((select) => {
    select.addEventListener('change', () => select.closest('form').submit());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-site-header]');
  if (header) {
    const update = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-media"] && !Shopify.designMode) return;
  try {
    
  // iOS Low Power Mode blocks autoplay; the first user gesture allows it
  const nudgeVideos = () => {
    document.querySelectorAll('video[autoplay]').forEach((v) => {
      if (v.paused) v.play().catch(() => {});
    });
  };
  ['touchstart', 'click'].forEach((evt) => {
    document.addEventListener(evt, nudgeVideos, { once: true, passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  const popup = document.querySelector('[data-newsletter-popup]');
  if (popup) {
    const KEY = 'alinette-nl-popup';
    const days = parseInt(popup.dataset.days, 10) || 30;
    const now = Date.now();

    const snoozed = () => {
      try {
        return parseInt(localStorage.getItem(KEY) || '0', 10) > now;
      } catch (e) {
        return true;
      }
    };
    const snooze = (d) => {
      try {
        localStorage.setItem(KEY, String(now + d * 86400000));
      } catch (e) {
        /* private mode */
      }
    };

    const signup = popup.querySelector('form.nl-popup__form');
    if (signup) {
      signup.addEventListener('submit', () => {
      const email = (form.querySelector('input[name="contact[email]"]') || {}).value || '';
      if (!email.trim()) return;
      try {
        // Abonare direct în Klaviyo (endpoint public, cheia publică a contului),
        // în paralel cu submit-ul nativ Shopify; keepalive supraviețuiește navigării.
        // Flow-ul "Subscribed to List" din Klaviyo trimite emailul cu codul unic.
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TcRxwK', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Website newsletter form',
                profile: { data: { type: 'profile', attributes: { email: email.trim() } } },
              },
              relationships: { list: { data: { type: 'list', id: 'Y2UTHa' } } },
            },
          }),
        }).catch(() => {});
      } catch (e) {
        /* best-effort */
      }
      });
    }

    popup.addEventListener('close', () => snooze(days));
    popup.addEventListener('click', (e) => {
      if (e.target === popup) popup.close();
    });

    if (popup.querySelector('[data-popup-success]')) {
      // Post-submit reload: show the thank-you state once, then stay
      // quiet for a year. A back-in-stock signup also posts a customer
      // form — that success belongs to the PDP, not this popup.
      snooze(365);
      if (!window.location.search.includes('notified=1')) popup.showModal();
    } else if (popup.dataset.designMode !== undefined) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.target.contains(popup)) popup.showModal();
      });
      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.target.contains(popup) && popup.open) popup.close();
      });
    } else if (!snoozed()) {
      setTimeout(() => {
        if (!popup.open) popup.showModal();
      }, parseInt(popup.dataset.delay, 10) || 5000);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('form.newsletter__form').forEach((form) => {
    form.addEventListener('submit', () => {
      const email = (form.querySelector('input[name="contact[email]"]') || {}).value || '';
      if (!email.trim()) return;
      try {
        // Abonare direct în Klaviyo (endpoint public, cheia publică a contului),
        // în paralel cu submit-ul nativ Shopify; keepalive supraviețuiește navigării.
        // Flow-ul "Subscribed to List" din Klaviyo trimite emailul cu codul unic.
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TcRxwK', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Website newsletter form',
                profile: { data: { type: 'profile', attributes: { email: email.trim() } } },
              },
              relationships: { list: { data: { type: 'list', id: 'Y2UTHa' } } },
            },
          }),
        }).catch(() => {});
      } catch (e) {
        /* best-effort */
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const form = document.querySelector('[data-product-form]') || document.querySelector('form[action*="/cart/add"]');
  const jsonEl = document.querySelector('[data-product-json]');

  if (form && jsonEl) {
    const { strings, variants } = JSON.parse(jsonEl.textContent);
    const variantInput = form.querySelector('[data-variant-id]');
    const priceEl = document.querySelector('[data-price]');
    const atcButton = form.querySelector('[data-add-to-cart]');
    const atcLabel = form.querySelector('[data-atc-label]');

    const selectedOptions = () =>
      [...form.querySelectorAll('.product__option')].map(
        (fieldset) => fieldset.querySelector('[data-option-input]:checked')?.value
      );

    const gallery = document.querySelector('[data-product-gallery]');
    const colorIdx = gallery ? parseInt(gallery.dataset.colorOptionIndex, 10) : -1;
    const handleize = (value) =>
      value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

    let currentColor = null;

    const filterGallery = (colorValue) => {
      if (!gallery || colorIdx < 0 || !colorValue) return;
      const target = handleize(colorValue);
      const colorChanged = currentColor !== null && target !== currentColor;
      currentColor = target;
      const items = [...gallery.querySelectorAll('[data-media-color]')];
      const hasMatch = items.some((el) => el.dataset.mediaColor === target);
      items.forEach((el) => {
        el.hidden = hasMatch ? el.dataset.mediaColor !== target : false;
      });
      if (!hasMatch) return;
      // Back to the first photo of the new colorway
      if (gallery.scrollLeft) gallery.scrollTo({ left: 0 });
      if (colorChanged && window.matchMedia('(min-width: 990px)').matches) {
        const header = document.querySelector('[data-site-header]');
        const offset = header ? header.offsetHeight : 0;
        const top = gallery.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      }
    };

    // Broadcast the selected color so other sections (Complete the set)
    // can mirror it
    const announceColor = (value) => {
      if (!value) return;
      const handle = handleize(value);
      document.documentElement.dataset.selectedColor = handle;
      document.dispatchEvent(new CustomEvent('alinette:color', { detail: { handle } }));
    };

    const preloadGroup = (handle) => {
      if (!gallery) return;
      gallery
        .querySelectorAll('[data-media-color="' + handle + '"] img[loading="lazy"]')
        .forEach((img) => {
          img.loading = 'eager';
        });
    };

    // Hidden colorways never intersect the viewport, so lazy images would
    // only start loading on switch. Prefetch them once the page settles.
    const prefetchAll = () => {
      if (!gallery) return;
      gallery
        .querySelectorAll('[data-media-color][hidden] img[loading="lazy"]')
        .forEach((img, i) => {
          setTimeout(() => {
            img.loading = 'eager';
          }, i * 200);
        });
    };
    if ('requestIdleCallback' in window) requestIdleCallback(prefetchAll, { timeout: 5000 });
    else setTimeout(prefetchAll, 3000);

    const onChange = () => {
      const options = selectedOptions();
      if (colorIdx > -1) {
        filterGallery(options[colorIdx]);
        announceColor(options[colorIdx]);
      }
      const variant = variants.find((v) =>
        options.every((value, i) => !value || v.options[i] === value)
      );

      form.querySelectorAll('.product__option').forEach((fieldset, i) => {
        const label = fieldset.querySelector('[data-option-value]');
        if (label && options[i]) label.textContent = options[i];
      });

      if (!variant) {
        if (atcButton) atcButton.disabled = true;
        if (atcLabel) atcLabel.textContent = strings.unavailable;
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (priceEl) {
        priceEl.textContent = variant.price;
        if (variant.comparePrice) {
          const s = document.createElement('s');
          s.textContent = variant.comparePrice;
          priceEl.append(' ', s);
        }
      }
      if (atcButton) atcButton.disabled = !variant.available;
      if (atcLabel) atcLabel.textContent = variant.available ? strings.addToCart : strings.soldOut;

      const notify = document.querySelector('[data-notify]');
      if (notify) {
        notify.hidden = variant.available;
        const tags = notify.querySelector('[data-notify-tags]');
        if (tags) {
          const suffix = variant.options.map((o) => handleize(o)).join('-');
          tags.value = tags.dataset.base + ',' + notify.dataset.handlePrefix + '-' + suffix;
        }
        const ret = notify.querySelector('[data-notify-return]');
        if (ret) {
          ret.value = window.location.pathname + '?variant=' + variant.id + '&notified=1';
        }
      }

      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    form.querySelectorAll('[data-option-input]').forEach((input) => {
      input.addEventListener('change', onChange);
    });

    // Returning from a notify signup: swap the form for the thank-you note
    if (window.location.search.includes('notified=1')) {
      const notify = document.querySelector('[data-notify]');
      if (notify) {
        notify.hidden = false;
        const notifyForm = notify.querySelector('form');
        if (notifyForm) notifyForm.hidden = true;
        const success = notify.querySelector('[data-notify-success]');
        if (success) success.hidden = false;
      }
    }

    // Gallery lightbox: click a photo to zoom, navigate within the
    // visible colorway
    const lightbox = document.querySelector('[data-lightbox]');
    if (lightbox && gallery) {
      const lbImg = lightbox.querySelector('[data-lb-img]');
      let items = [];
      let idx = 0;

      const render = () => {
        const el = items[idx];
        if (!el) return;
        lbImg.src = el.dataset.full;
        lbImg.alt = (el.querySelector('img') || {}).alt || '';
        const next = items[(idx + 1) % items.length];
        if (next) new Image().src = next.dataset.full;
      };

      const ZOOM = 2.5;
      let zoomed = false;
      let tx = 0;
      let ty = 0;

      // Stable reference frame: the viewport-sized dialog, never the
      // transformed image box (that feedback loop is what made panning jump)
      const bounds = () => {
        const r = lightbox.getBoundingClientRect();
        return { cx: r.left + r.width / 2, cy: r.top + r.height / 2, hw: r.width / 2, hh: r.height / 2 };
      };

      const clampPan = () => {
        const b = bounds();
        const maxX = b.hw * (ZOOM - 1);
        const maxY = b.hh * (ZOOM - 1);
        tx = Math.max(-maxX, Math.min(maxX, tx));
        ty = Math.max(-maxY, Math.min(maxY, ty));
      };

      const apply = () => {
        lbImg.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + ZOOM + ')';
      };

      const zoomOut = () => {
        zoomed = false;
        tx = 0;
        ty = 0;
        lbImg.style.transform = '';
        lbImg.classList.remove('is-zoomed');
      };

      const zoomIn = (clientX, clientY) => {
        const b = bounds();
        tx = (clientX - b.cx) * (1 - ZOOM);
        ty = (clientY - b.cy) * (1 - ZOOM);
        clampPan();
        lbImg.classList.add('is-zoomed');
        zoomed = true;
        apply();
      };

      const step = (delta) => {
        if (!items.length) return;
        zoomOut();
        idx = (idx + delta + items.length) % items.length;
        render();
      };

      gallery.addEventListener('click', (e) => {
        const media = e.target.closest('[data-full]');
        if (!media || media.hidden) return;
        items = [...gallery.querySelectorAll('[data-full]:not([hidden])')];
        idx = Math.max(items.indexOf(media), 0);
        render();
        lightbox.showModal();
      });

      lightbox.querySelector('[data-lb-prev]').addEventListener('click', () => step(-1));
      lightbox.querySelector('[data-lb-next]').addEventListener('click', () => step(1));
      lightbox.querySelector('[data-lb-close]').addEventListener('click', () => {
        zoomOut();
        lightbox.close();
      });

      // Click/tap the photo: magnify anchored on that spot; again to fit
      let suppressClick = false;
      lbImg.addEventListener('click', (e) => {
        if (suppressClick) {
          suppressClick = false;
          return;
        }
        if (zoomed) zoomOut();
        else zoomIn(e.clientX, e.clientY);
      });

      // Desktop: while zoomed, the cursor position maps across the photo
      lightbox.addEventListener('pointermove', (e) => {
        if (!zoomed || e.pointerType !== 'mouse') return;
        const b = bounds();
        tx = (b.cx - e.clientX) * (ZOOM - 1);
        ty = (b.cy - e.clientY) * (ZOOM - 1);
        clampPan();
        apply();
      }, { passive: true });

      // Mobile: while zoomed, the image follows the finger (natural drag)
      let drag = null;
      lightbox.addEventListener('touchstart', (e) => {
        if (zoomed && e.touches.length === 1) {
          drag = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: tx, ty: ty, moved: false };
        }
      }, { passive: true });
      lightbox.addEventListener('touchmove', (e) => {
        if (!zoomed || !drag || e.touches.length !== 1) return;
        const dx = e.touches[0].clientX - drag.x;
        const dy = e.touches[0].clientY - drag.y;
        if (Math.abs(dx) + Math.abs(dy) > 8) drag.moved = true;
        tx = drag.tx + dx;
        ty = drag.ty + dy;
        clampPan();
        apply();
      }, { passive: true });
      lightbox.addEventListener('touchend', () => {
        if (drag && drag.moved) suppressClick = true;
        drag = null;
      }, { passive: true });

      lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox) {
          zoomOut();
          lightbox.close();
        }
      });
      lightbox.addEventListener('close', zoomOut);
      lightbox.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') step(1);
        if (e.key === 'ArrowLeft') step(-1);
      });

      let touchX = null;
      lightbox.addEventListener('touchstart', (e) => {
        touchX = e.touches[0].clientX;
      }, { passive: true });
      lightbox.addEventListener('touchend', (e) => {
        if (touchX === null || zoomed) {
          touchX = null;
          return;
        }
        const delta = e.changedTouches[0].clientX - touchX;
        if (Math.abs(delta) > 40) step(delta < 0 ? 1 : -1);
        touchX = null;
      }, { passive: true });
    }

    // AJAX add to cart: stay on the page, open the global cart drawer
    form.addEventListener('submit', (e) => {
      if (!window.AlinetteCartDrawer) return;
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
        .then((r) => {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(() => window.AlinetteCartDrawer.open())
        .catch(() => {
          // No-JS-grade fallback: classic submit to the cart page
          form.submit();
        })
        .finally(() => {
          if (btn) btn.disabled = false;
        });
    });

    // Back in Stock nativ Klaviyo: la înscrierea în notify, abonează emailul
    // la varianta exactă (produs + mărime) prin endpoint-ul public. Klaviyo
    // urmărește stocul prin integrarea Shopify și trimite singur emailul la
    // restock. Tag-urile Shopify din formular rămân ca evidență/backup.
    const notifyBlock = document.querySelector('[data-notify]');
    if (notifyBlock) {
      const notifyForm = notifyBlock.querySelector('form');
      if (notifyForm) {
        notifyForm.addEventListener('submit', () => {
          const email = (notifyForm.querySelector('input[type="email"]') || {}).value || '';
          const ret = (notifyForm.querySelector('[data-notify-return]') || {}).value || '';
          const m = ret.match(/variant=(\d+)/);
          if (!email.trim() || !m) return;
          try {
            fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=TcRxwK', {
              method: 'POST',
              keepalive: true,
              headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
              body: JSON.stringify({
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    channels: ['EMAIL'],
                    profile: { data: { type: 'profile', attributes: { email: email.trim() } } },
                  },
                  relationships: {
                    variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + m[1] } },
                  },
                },
              }),
            }).catch(() => {});
          } catch (e) {
            /* best-effort */
          }
        });
      }
    }

    document.querySelectorAll('[data-open-dialog]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dialog = document.getElementById(btn.dataset.openDialog);
        if (dialog) dialog.showModal();
      });
    });

    document.querySelectorAll('.pdp-dialog').forEach((dialog) => {
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
      });
    });

    // Hovering a swatch preloads that colorway before the click lands
    form.querySelectorAll('.product__value--swatch').forEach((label) => {
      label.addEventListener(
        'pointerenter',
        () => {
          const input = label.querySelector('input');
          if (input) preloadGroup(handleize(input.value));
        },
        { once: true }
      );
    });

    if (colorIdx > -1) {
      const initial = selectedOptions();
      if (initial[colorIdx]) {
        currentColor = handleize(initial[colorIdx]);
        announceColor(initial[colorIdx]);
      }
    }
  }

  } catch(e) { console.error(e); }
})();
})();
